import { Action } from '@ngrx/store';
import { SurveyInterface } from 'app/assessment/survey/models';

import { SurveyActionType } from './survey-action-type.enum';

// surveys
export class LoadSurveys implements Action {
  public readonly type: SurveyActionType = SurveyActionType.LoadSurveys;

  constructor(public readonly payload: number) { }
}

export class LoadSurveysCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.LoadSurveysCompleted;

  constructor(public readonly payload: SurveyInterface[]) { }
}

export class LoadSurveysFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.LoadSurveysFailed;

  constructor(public readonly payload: string) { }
}

// current survey
export class LoadCurrentSurvey implements Action {
  public readonly type: SurveyActionType = SurveyActionType.LoadCurrentSurvey;

  constructor(public readonly payload: number) { }
}

export class LoadCurrentSurveyCompleted implements Action {
  public readonly type: SurveyActionType = SurveyActionType.LoadCurrentSurveyCompleted;

  constructor(public readonly payload: SurveyInterface) { }
}

export class LoadCurrentSurveyFailed implements Action {
  public readonly type: SurveyActionType = SurveyActionType.LoadCurrentSurveyFailed;

  constructor(public readonly payload: string) { }
}
